import React from "react";
import Icon from "./Icon";

const DeleteSvg = () => <Icon name="delete" className=" h-4 w-4" strokeWidth="2" />;

export default DeleteSvg;
